var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f4f4f4;\n      }\n\n      .st0, .st1, .st2 {\n        fill-rule: evenodd;\n      }\n\n      .st1, .st3 {\n        fill: #3d9348;\n      }\n\n      .st4, .st2 {\n        fill: #d61e34;\n      }\n\n      .st5 {\n        fill: #b5202e;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 0,
    width: 21,
    height: 15,
    rx: 3.1,
    ry: 3.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    width: 7,
    height: 15,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "17.1 15 17.1 0 10.1 0 10.1 15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "11 15 11 0 4 0 4 15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "14 15 14 0 7 0 7 15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 14,
    width: 7,
    height: 15,
    rx: 3,
    ry: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.dbc2ab81387ef18f370fe19c86d8a3b2.svg";
export { ForwardRef as ReactComponent };